document.addEventListener("DOMContentLoaded", function() {
  let index = 0;
  const slides = document.querySelectorAll(".slide-lop-slide");
  const totalSlides = slides.length;
  const slider = document.querySelector(".slide-lop-slider");

  function updateSlide() {
    slider.style.transform = `translateX(-${index * 100}%)`;
  }

  document.querySelector(".slide-lop-next").addEventListener("click", function() {
    index = (index + 1) % totalSlides;
    updateSlide();
  });

  document.querySelector(".slide-lop-prev").addEventListener("click", function() {
    index = (index - 1 + totalSlides) % totalSlides;
    updateSlide();
  });

  if (totalSlides > 1) {
    setInterval(() => {
      index = (index + 1) % totalSlides;
      updateSlide();
    }, 4000); // Cambia cada 4 segundos
  }
});